import { render, staticRenderFns } from "./UsageReport.vue?vue&type=template&id=c806309e&scoped=true&"
import script from "./UsageReport.vue?vue&type=script&lang=js&"
export * from "./UsageReport.vue?vue&type=script&lang=js&"
import style0 from "./UsageReport.vue?vue&type=style&index=0&id=c806309e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c806309e",
  null
  
)

export default component.exports